/**
 * @generated SignedSource<<a6a2978c5e422a401ccc88ee79f445d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DashboardTable_getLocationsWithMachineCountsQuery$variables = {};
export type DashboardTable_getLocationsWithMachineCountsQuery$data = {
  readonly getLocationsWithMachineCounts: ReadonlyArray<{
    readonly createdAt: any | null;
    readonly createdBy: {
      readonly firstName: string;
      readonly id: string;
    } | null;
    readonly customer: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly id: string;
    readonly name: string;
    readonly uuid: string | null;
  }>;
};
export type DashboardTable_getLocationsWithMachineCountsQuery = {
  response: DashboardTable_getLocationsWithMachineCountsQuery$data;
  variables: DashboardTable_getLocationsWithMachineCountsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LocationObjectType",
    "kind": "LinkedField",
    "name": "getLocationsWithMachineCounts",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomerObjectType",
        "kind": "LinkedField",
        "name": "customer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserObjectType",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardTable_getLocationsWithMachineCountsQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DashboardTable_getLocationsWithMachineCountsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a0b8e672250ccdc1f87f7d8bfd4029d1",
    "id": null,
    "metadata": {},
    "name": "DashboardTable_getLocationsWithMachineCountsQuery",
    "operationKind": "query",
    "text": "query DashboardTable_getLocationsWithMachineCountsQuery {\n  getLocationsWithMachineCounts {\n    id\n    uuid\n    customer {\n      id\n      name\n    }\n    name\n    createdAt\n    createdBy {\n      id\n      firstName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "32eb77772c6b5f7089119aac0de45645";

export default node;
